import axios from '_u/axios'

export const login = (body) => {
    return axios.post('api/cas/pcLogin', body).then(res => {
        var data = res.data,
            user = data.info || data.user || data.passport

        // 登录信息统一都放到user里
        Object.keys(data).forEach(k => {
            if (k != 'info' && k != 'user' && k != 'passport') {
                user[k] = data[k]
            }
        })

        res.data = { user }

        return res
    })
}

export const wxLogin = (body) => {
    return axios.post('api/cas/wxLogin', body)
}

export const mpLogin = (body) => {
    return axios.post('api/cas/mpLogin', body)
}

export const openIdLogin = (openId) => {
    return axios.post('api/cas/openIdLogin', { openId })
}

export const logout = (body) => {
    return axios.post('api/cas/logout', body)
}

export const getUserInfo = (body) => {
    if (process.env.VUE_APP_IDENTITY_AUTH == "token") {
        return axios.post('api/admin/sys/user/info', body)
    }

    if (process.env.VUE_APP_IDENTITY_AUTH == "session") {
        return axios.post('api/cas/info', body)
    }
}

// 查询用户列表
export const userList = (body) => {
    return axios.post('api/sys/user/list', body)
}

// 新增用户
export const userAdd = (body) => {
    return axios.post('api/sys/user/add', body)
}

// 修改用户
export const userUpdate = (body) => {
    return axios.post('api/sys/user/update', body)
}

// 删除用户
export const userDelete = (id) => {
    return axios.post('api/sys/user/delete', { id })
}

// 查看用户
export const userView = (id) => {
    return axios.post('api/sys/user/view', { id })
}

// 用户启用
export const userEnable = (userId) => {
    return axios.post('api/sys/user/enabled', {
        id: userId
    })
}

// 用户禁用
export const userDisable = (userId) => {
    return axios.post('api/sys/user/disable', {
        id: userId
    })
}

// 重制密码
export const userReset = (userId) => {
    return axios.post('api/sys/user/resetPwd', {
        id: userId
    })
}

// 查询用户可分配的角色
export const userRole = () => {
    return axios.post('api/sys/role/allRole')
}

//验证用户名
export const validateName = (username, id) => {
    return axios.post('api/sys/user/validateName', { username, id })
}

//验证旧密码
export const validOldPwd = (oldPwd) => {
    return axios.post('api/sys/user/validOldPwd', { oldPwd })
}

//修改密码
export const updateOnwerPwd = (newPwd) => {
    return axios.post('api/sys/user/updateOnwerPwd', { newPwd })
}

// 汉子转拼音
export const toPinYin = (id, nickName) => {
    return axios.post('api/sys/user/toPinYin', { id, nickName })
}